type RouteLoader = () => Promise<unknown>;

export const loadHome = () => import("./pages/Home");
export const loadFornecedoresGate = () => import("./pages/FornecedoresGate");
export const loadAnunciante = () => import("./pages/Anunciante");
export const loadPublicAdvertiser = () => import("./pages/PublicAdvertiser");
export const loadAdmin = () => import("./pages/Admin");
export const loadAdminAnuncios = () => import("./pages/AdminAnuncios");
export const loadAdminMensagens = () => import("./pages/AdminMensagens");
export const loadAdminMembros = () => import("./pages/AdminMembros");
export const loadAdminAnunciantes = () => import("./pages/AdminAnunciantes");
export const loadAdminNoticias = () => import("./pages/AdminNoticias");
export const loadAdminConteudo = () => import("./pages/AdminConteudo");
export const loadAdminAcademy = () => import("./pages/AdminAcademy");
export const loadLoginCadastro = () => import("./pages/LoginCadastro");
export const loadAssinatura = () => import("./pages/Assinatura");
export const loadCheckoutAssinatura = () =>
  import("./pages/CheckoutAssinatura");
export const loadConteudo = () => import("./pages/Conteudo");
export const loadContato = () => import("./pages/Contato");
export const loadAnunciePlanos = () => import("./pages/AnunciePlanos");
export const loadAnuncieCheckout = () => import("./pages/AnuncieCheckout");
export const loadAnuncieCadastro = () => import("./pages/AnuncieCadastro");
export const loadMapaLimeira = () => import("./pages/MapaLimeira");
export const loadHoteisPousadas = () => import("./pages/HoteisPousadas");
export const loadPrimeClubBeneficios = () =>
  import("./pages/PrimeClubBeneficios");
export const loadPrimeClubCard = () => import("./pages/PrimeClubCard");
export const loadPrimeValidation = () => import("./pages/PrimeValidation");
export const loadHappApps = () => import("./pages/HappApps");
export const loadNoticias = () => import("./pages/Noticias");
export const loadQuemSomos = () => import("./pages/QuemSomos");
export const loadAcademy = () => import("./pages/Academy");
export const loadAcademyCourseDetail = () =>
  import("./pages/AcademyCourseDetail");
export const loadAcademyStudentDashboard = () =>
  import("./pages/AcademyStudentDashboard");
export const loadAcademyCertificateValidation = () =>
  import("./pages/AcademyCertificateValidation");

const ROUTE_LOADERS: Array<
  [matcher: (pathname: string) => boolean, loader: RouteLoader]
> = [
  [pathname => pathname === "/", loadHome],
  [
    pathname =>
      pathname === "/fornecedores" ||
      pathname === "/categorias" ||
      pathname === "/hoteis-pousadas" ||
      pathname.startsWith("/fornecedores/"),
    loadFornecedoresGate,
  ],
  [pathname => pathname === "/anunciante", loadAnunciante],
  [pathname => pathname.startsWith("/anunciante/"), loadPublicAdvertiser],
  [pathname => pathname === "/admin", loadAdmin],
  [pathname => pathname === "/admin/anuncios", loadAdminAnuncios],
  [pathname => pathname === "/admin/mensagens", loadAdminMensagens],
  [pathname => pathname === "/admin/membros", loadAdminMembros],
  [pathname => pathname === "/admin/anunciantes", loadAdminAnunciantes],
  [pathname => pathname === "/admin/noticias", loadAdminNoticias],
  [pathname => pathname === "/admin/conteudo", loadAdminConteudo],
  [pathname => pathname === "/admin/academy", loadAdminAcademy],
  [
    pathname => pathname === "/login" || pathname === "/cadastro",
    loadLoginCadastro,
  ],
  [pathname => pathname === "/checkout", loadCheckoutAssinatura],
  [pathname => pathname === "/assinatura", loadAssinatura],
  [pathname => pathname === "/prime-club", loadPrimeClubBeneficios],
  [pathname => pathname === "/prime-carteirinha", loadPrimeClubCard],
  [pathname => pathname === "/prime-validar", loadPrimeValidation],
  [pathname => pathname === "/tecnologia-happ-apps", loadHappApps],
  [pathname => pathname === "/quem-somos", loadQuemSomos],
  [pathname => pathname === "/academy", loadAcademy],
  [pathname => pathname === "/academy/aluno", loadAcademyStudentDashboard],
  [
    pathname => pathname === "/academy/validar",
    loadAcademyCertificateValidation,
  ],
  [pathname => pathname.startsWith("/academy/curso/"), loadAcademyCourseDetail],
  [
    pathname => pathname === "/descobrir" || pathname === "/programas",
    loadConteudo,
  ],
  [
    pathname => pathname === "/noticias" || pathname.startsWith("/noticias/"),
    loadNoticias,
  ],
  [pathname => pathname === "/anuncie/checkout", loadAnuncieCheckout],
  [pathname => pathname === "/anuncie/cadastro", loadAnuncieCadastro],
  [pathname => pathname === "/anuncie", loadAnunciePlanos],
  [pathname => pathname === "/contato", loadContato],
  [pathname => pathname === "/mapa", loadMapaLimeira],
  [pathname => pathname === "/pousada-recanto-portugues", loadHoteisPousadas],
];

export function prefetchRoute(pathname: string) {
  const loader = ROUTE_LOADERS.find(([matcher]) => matcher(pathname))?.[1];
  if (!loader) return;
  void loader().catch(() => {
    // A navegação continua capaz de tentar carregar o módulo quando necessário.
  });
}

export function isPrefetchableInternalPath(pathname: string) {
  return (
    pathname.startsWith("/") &&
    !pathname.startsWith("//") &&
    !pathname.startsWith("/api/") &&
    !pathname.startsWith("/manus-storage/")
  );
}

export function getInternalPath(href: string) {
  if (typeof window === "undefined") return null;
  try {
    const url = new URL(href, window.location.href);
    if (url.origin !== window.location.origin) return null;
    if (!isPrefetchableInternalPath(url.pathname)) return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}

export function getPrefetchPath(href: string) {
  if (typeof window === "undefined") return null;
  try {
    const url = new URL(href, window.location.href);
    if (
      url.origin !== window.location.origin ||
      !isPrefetchableInternalPath(url.pathname)
    ) {
      return null;
    }
    return url.pathname;
  } catch {
    return null;
  }
}
